import { createAction } from "@ngrx/store";

export const showHelp = createAction("[Help] show help");
export const closeHelp = createAction("[Help] hide help");